import { api, apiNet } from '@cems-eco/core/src/services/api';

export abstract class BaseMaintenanceApi {
    BASE_URL: string;

    
    constructor() {
        this.BASE_URL = "/maintenance";
    }

    async all(): Promise<any> {
        return await api.get<any>(this.BASE_URL);
    }

    async first(id: any, params: any): Promise<any> {
        return await api.get<any>(`${this.BASE_URL}/${id}`, params);
    }

    async create(data: any): Promise<any> {
        return await api.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await api.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async download(fileName: string, id: any): Promise<any> {
        return await api.downloadFile<any>(`${this.BASE_URL}/pdf/${id}`, fileName);
    }

    async destroy(id: any): Promise<any> {
        return await api.delete<any>(`${this.BASE_URL}/${id}`);
    }

    async storeRelation(data: any): Promise<any> {
        return await api.post<any>(`${this.BASE_URL}/relation/store`, data);
    }

    async updateRelation(id: any, data: any): Promise<any> {
        return await api.post<any>(`${this.BASE_URL}/relation/${id}`, data);
    }

    async deleteRelation(id: any): Promise<any> {
        return await api.delete<any>(`${this.BASE_URL}/relation/${id}`);
    }

    async serialNumber(): Promise<any> {
        return await api.get<any>(`${this.BASE_URL}/serial-number`);
    }

    async clientFirst(id: any): Promise<any> {
        return await api.get<any>(`/client/${id}`);
    }

    async siteFirst(id: any): Promise<any> {
        return await api.get<any>(`/site/${id}`);
    }


    async getEquipmentBySite(id: any): Promise<any> {
        const params = {
            search: {
                advanced: {
                    site_id: id
                }
            }
        }
        return await api.get<any>(`/equipment`, params);
    }

    async equipmentFirst(id: any): Promise<any> {
        return await api.get<any>(`/equipment/${id}`);
    }

    async userFirst(id: any): Promise<any> {
        return await api.get<any>(`/user/${id}`);
    }

    getUrl(url, params = {}): string {
        return api.getUrl(url, params);
    }

    async getOptions(url, params = {}, keyValue = 'id', extraKeys: any = {}): Promise<any[]> {
        let response = await api.get<any>(url, params);

        return (response.data as any[]).map((e) => {
            const extra = {};
            for (const index of Object.keys(extraKeys)) {
                const key = extraKeys[index];
                extra[key] = e[key] ?? null;
            }
            return ({
                label: e.text,
                value: e[keyValue],
                ...extra
            });
        });
    }
}
